import React from "react";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline"; // Cleaner icon

const ChatHeaderActions = ({
  onAddChat,
  showAddChat = true,
  toggleChatsListPanel = () => {},
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{ cursor: "default" }}
    >
      {/* 'Chats' label as clickable text */}
      <Typography
        variant="body2"
        onClick={toggleChatsListPanel}
        sx={{
          fontWeight: 500,
          fontSize: 14,
          color: "#333",
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
            color: "#000",
          },
        }}
      >
        Chats
      </Typography>

      {showAddChat && (
        <Tooltip title="New Chat">
          <IconButton
            onClick={onAddChat}
            sx={{
              p: 0.5,
              color: "#111",
              "&:hover": { color: "#000" },
            }}
          >
            <AddCircleIcon sx={{ fontSize: 22 }} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};

export default ChatHeaderActions;
